import { Helmet } from "react-helmet-async";



const SITE_NAME = "Keystone Insurance Brokers Ltd";
const BASE_URL  = "https://www.keystoneinsurance.ca";
const DEFAULT_IMAGE = `${BASE_URL}/keystonelogo.png`;

export default function SEO({ title, description, canonical }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title"       content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url"         content={canonical} />
      <meta property="og:image"       content={DEFAULT_IMAGE} />
      <meta property="og:site_name"   content={SITE_NAME} />
      <meta property="og:type"        content="website" />

    </Helmet>
  );
}